<template>
    <wizard-data-provider>
        <template v-slot:default="{}">
            <div class="wizard-contact-step">
                <ui-accordion :is-passive="true"
                        :is-open="currentSubStep === 0"
                        class="wizard-contact-step--collapsible"
                        ref="enrollee_accordion">
                    <template slot="head">
                        <div class="wizard-contact-step--head" :class="getHeadClasses(0)">
                            <div class="wizard-contact-step--head-text">
                                <slot name="enrollee_title"/>
                            </div>
                            <div class="wizard-contact-step--head-icon">
                                <button class="btn btn__icon wizard-contact-step--head-edit" @click="onEdit(0)">
                                    <ui-icon size="medium" symbol="edit"/>
                                </button>
                            </div>
                        </div>
                        <form-field-messages class="wizard-contact-step--messages"
                                :messages="{ error: ['Bitte überprüfen Sie Ihre Angaben'] }"
                                v-if="showSubStepError(0)"/>
                    </template>
                    <template slot="body">
                        <div class="wizard-contact-step--body">
                            <div class="wizard-form--field-row">
                                <slot name="enrollee_01"/>
                                <template v-if="showLegalGuardian1">
                                    <slot name="enrollee_02"/>
                                </template>
                                <slot name="enrollee_03"/>
                            </div>
                            <slot name="enrollee_checks"/>
                        </div>
                    </template>
                </ui-accordion>
                <ui-accordion :is-passive="true"
                        :is-open="currentSubStep === 1 && !useEnroleeBillingAddress"
                        class="wizard-contact-step--collapsible"
                        ref="billing_address_accordion">
                    <template
                            v-if="!useEnroleeBillingAddress && !useBillingAddressLegalGuardian1 && !useBillingAddressLegalGuardian2"
                            slot="head">
                        <div class="wizard-contact-step--head" :class="getHeadClasses(1)">
                            <div class="wizard-contact-step--head-text">
                                <slot name="billing_address_title"/>
                            </div>
                            <div class="wizard-contact-step--head-icon">
                                <button class="btn btn__icon wizard-contact-step--head-edit" @click="onEdit(1)">
                                    <ui-icon size="medium" symbol="edit"/>
                                </button>
                            </div>
                        </div>
                        <form-field-messages
                                :messages="{ error: ['Bitte überprüfen Sie Ihre Angaben'] }"
                                v-if="showSubStepError(1)"/>
                    </template>
                    <template slot="body">
                        <div class="wizard-contact-step--body">
                            <slot name="billing_address"/>
                        </div>
                    </template>
                </ui-accordion>
                <ui-accordion :is-passive="true"
                        :is-open="currentSubStep === 2 && showLegalGuardian1"
                        class="wizard-contact-step--collapsible"
                        ref="legal_guardian_1_accordion">
                    <template v-if="showLegalGuardian1" slot="head">
                        <div class="wizard-contact-step--head" :class="getHeadClasses(2)">
                            <div class="wizard-contact-step--head-text">
                                <slot name="legal_guardian_1_title"/>
                            </div>
                            <div class="wizard-contact-step--head-icon">
                                <button class="btn btn__icon wizard-contact-step--head-edit" @click="onEdit(2)">
                                    <ui-icon size="medium" symbol="edit"/>
                                </button>
                            </div>
                        </div>
                        <form-field-messages
                                :messages="{ error: ['Bitte überprüfen Sie Ihre Angaben'] }"
                                v-if="showSubStepError(2)"/>
                    </template>
                    <template slot="body">
                        <div class="wizard-contact-step--body">
                            <slot name="legal_guardian_1"/>
                            <slot name="legal_guardian_1_checks"/>
                        </div>
                    </template>
                </ui-accordion>
                <ui-accordion :is-passive="true"
                        :is-open="currentSubStep === 3 && showLegalGuardian2"
                        class="wizard-contact-step--collapsible"
                        ref="legal_guardian_2_accordion">
                    <template v-if="showLegalGuardian2" slot="head">
                        <div class="wizard-contact-step--head" :class="getHeadClasses(3)">
                            <div class="wizard-contact-step--head-text">
                                <slot name="legal_guardian_2_title"/>
                            </div>
                            <div class="wizard-contact-step--head-icon">
                                <button class="btn btn__icon wizard-contact-step--head-edit" @click="onEdit(3)">
                                    <ui-icon size="medium" symbol="edit"/>
                                </button>
                            </div>
                        </div>
                        <form-field-messages
                                :messages="{ error: ['Bitte überprüfen Sie Ihre Angaben'] }"
                                v-if="showSubStepError(3)"/>
                    </template>
                    <template slot="body">
                        <div class="wizard-contact-step--body">
                            <slot name="legal_guardian_2"/>
                            <slot name="legal_guardian_2_checks"/>
                        </div>
                    </template>
                </ui-accordion>
                <ui-accordion :is-passive="true"
                        :is-open="currentSubStep === 4 && showApprenticeshipSupervisor"
                        class="wizard-contact-step--collapsible"
                        ref="apprenticeship_supervisor_accordion">
                    <template v-if="showApprenticeshipSupervisor" slot="head">
                        <div class="wizard-contact-step--head" :class="getHeadClasses(4)">
                            <div class="wizard-contact-step--head-text">
                                <slot name="apprenticeship_supervisor_title"/>
                            </div>
                            <div class="wizard-contact-step--head-icon">
                                <button class="btn btn__icon wizard-contact-step--head-edit" @click="onEdit(4)">
                                    <ui-icon size="medium" symbol="edit"/>
                                </button>
                            </div>
                        </div>
                        <form-field-messages
                                :messages="{ error: ['Bitte überprüfen Sie Ihre Angaben'] }"
                                v-if="showSubStepError(4)"/>
                    </template>
                    <template slot="body">
                        <div class="wizard-contact-step--body">
                            <slot name="apprenticeship_supervisor"/>
                            <slot name="apprenticeship_supervisor_checks"/>
                        </div>
                    </template>
                </ui-accordion>
            </div>
        </template>
    </wizard-data-provider>
</template>

<script>
    import bemMixin from '@dreipol/vue-ui/src/mixins/bem';
    import UiAccordion from '@dreipol/vue-ui/src/components/accordion/accordion';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import { mapActions, mapState } from 'vuex';
    import FormFieldMessages from '../form-field-messages/form-field-messages';
    import WizardDataProvider from '../wizard-data-provider/wizard-data-provider';

    const subStepNames = [
        'enrollee',
        'billing_address',
        'legal_guardian_1',
        'legal_guardian_2',
        'apprenticeship_supervisor',
    ];

    export default {
        components: {
            WizardDataProvider,
            FormFieldMessages,
            UiAccordion,
            UiIcon,
        },
        mixins: [bemMixin('wizard-contact-step')],
        props: {
            fieldErrors: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {};
        },
        computed: {
            ...mapState('wizard', ['furthestSubStep', 'currentSubStep', 'useEnroleeBillingAddress', 'showLegalGuardian1', 'showLegalGuardian2', 'showApprenticeshipSupervisor', 'useBillingAddressLegalGuardian1', 'useBillingAddressLegalGuardian2']),
            subStepsWithErrors() {
                return this.fieldErrors['__all__'] || [];
            },
        },
        methods: {
            ...mapActions('wizard', ['updateWizardSubStep']),
            getHeadClasses(subStepIdx) {
                return [
                    this.bemAdd(subStepIdx === this.currentSubStep ? 'is-active' : '', 'head'),
                    this.bemAdd(subStepIdx === this.currentSubStep ? '' : 'show-edit', 'head'),
                    this.bemAdd(this.hasStepErrors(subStepIdx) ? 'has-errors' : '', 'head'),
                ];
            },
            hasStepErrors(subStepIdx) {
                return this.subStepsWithErrors.includes(subStepNames[subStepIdx]);
            },
            showSubStepError(subStepIdx) {
                return this.hasStepErrors(subStepIdx) && subStepIdx !== this.currentSubStep;
            },
            scrollToSubStep(subStepIdx) {
                // wait for the accordion to open before scrolling
                setTimeout(() => {
                    const accordion = this.$refs[`${ subStepNames[subStepIdx] }_accordion`];
                    if (accordion) {
                        accordion.$el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }, 300);
            },
            onEdit(requestedSubStepIdx) {
                this.scrollToSubStep(requestedSubStepIdx);
                this.updateWizardSubStep({ value: requestedSubStepIdx });
            },
        },
    };
</script>
